/* eslint-disable node/no-unsupported-features/es-syntax */
import { PROFILE_ROUTE_NAMES } from "@/shared";
export const PROFILE_ROUTES = [
    {
        name: PROFILE_ROUTE_NAMES.PROFILE,
        path: "/my/profile",
        meta: {
            title: "words.profile",
        },
        component: () => import("../ui/ProfilePage.vue"),
    },
    {
        name: PROFILE_ROUTE_NAMES.EDIT,
        path: "/my/profile/edit",
        meta: {
            title: "words.edit_profile",
        },
        component: () => import("../ui/ProfileEdit.vue"),
    },
];
